import { Fragment, memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage, useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import type { LOGIN_FAILURE_REASONS } from '@didaskill/domain/auth/constants';
import { Toast } from '@didaskill/ui/design-system';
import { LoadingScreen } from '@didaskill/ui/domain';
import { useQueryString } from '@didaskill/ui/utils';

import { useAuth } from '../../context/auth-context';
import LoginPage from '../../pages/login/LoginPage';
import routes from '../../routes';
import messages from './LoginView.messages';

export const LoginViewBase = () => {
  const intl = useIntl();
  const {
    error,
    reason,
    origin,
  }: {
    error?: 'true';
    reason?: LOGIN_FAILURE_REASONS;
    origin?: string;
  } = useQueryString();

  const { user, error: errorAuth, isLoading } = useAuth();

  if (errorAuth && 'response' in errorAuth && errorAuth.response.statusCode === 500) {
    toast.error(
      <Toast>
        <FormattedMessage {...messages.AUTH_SERVICE_UNAVAILABLE_ERROR} />
      </Toast>,
    );
  }

  if (user && !isLoading) {
    return <Navigate to={origin || routes.APP.ROOT} replace />;
  }

  return isLoading ? (
    <Fragment>
      <Helmet>
        <title>{intl.formatMessage(messages.LOGIN)}</title>
      </Helmet>

      <LoadingScreen />
    </Fragment>
  ) : (
    <Fragment>
      <Helmet>
        <title>{intl.formatMessage(messages.LOGIN)}</title>
      </Helmet>

      <LoginPage error={error === 'true'} reason={reason} />
    </Fragment>
  );
};

LoginViewBase.displayName = 'LoginView';

export default memo(LoginViewBase);
